import React from "react";

export default function ServiceBox({ title, subtitle }) {
  return (
    <div className="w-full">
      <h2 className="mx-auto max-w-xs text-base font-normal">{title}</h2>
      {subtitle && <p className="mx-auto max-w-xs">{subtitle}</p>}
    </div>
  );
}
